import { $radius_border_base } from '../pebbleGlobalToken/border.js';
import { $color_grey_5, $color_grey_9, $color_grey_1, $color_grey_8, $color_grey_2, $color_brand_text_defalut, $color_grey_4, $color_grey_6, $color_red_6 } from '../pebbleGlobalToken/color.js';

/**
 * 选择器-颜色-边框
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $select_color_border = $color_grey_5;

/**
 * 选择器-颜色-文本
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $select_color_text = $color_grey_9;

/**
 * 选择器-颜色-dropdown-默认背景色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-1
 */
var $select_dropdown_option_bg_color = $color_grey_1;

/**
 * 选择器-颜色-dropdown-字体颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-8
 */
var $select_dropdown_option_color = $color_grey_8;

/**
 * 选择器-选中状态: item背景
 * @description enDesc: -
 * @description type: Color
 * @description value: color_grey_2
 */
var $select_control_item_bg_active = $color_grey_2;

/**
 * 选择器-选中状态: color
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_defalut
 */
var $select_dropdown_active_color = $color_brand_text_defalut;

/**
 * 选择器-item 背景 hover状态
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-1
 */
var $select_control_item_bg_hover = $color_grey_1;

/**
 * 选择器-dropdown hover状态
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_defalut
 */
var $select_dropdown_hover_color = $color_brand_text_defalut;

/**
 * 选择器-文本禁用颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $select_color_text_disabled = $color_grey_4;

/**
 * 选择器-multiple 次级填充色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $select_color_fill_secondary = $color_grey_2;

/**
 * 选择器-较小边框圆角
 * @description enDesc: -
 * @description type: Border
 * @description value: $radius-border-base
 */
// export const $select_border_radius_sm = presetTokens.$radius_border_base;

/**
 * 选择器-分割颜色 默认和禁用状态共用
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $select_color_split = $color_grey_4;

/**
 * 选择器-multiple item项文本颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-8
 */
var $select_multiple_item_color_text = $color_grey_8;

/**
 * 选择器-multiple item项文本禁用颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-6
 */
var $select_multiple_item_disabled_color = $color_grey_6;

/**
 * 选择器-更小边框圆角
 * @description enDesc: -
 * @description type: Border
 * @description value: $radius-border-base
 */
var $select_border_radius_xs = $radius_border_base;

/**
 * 选择器-input(single) 边框hover状态下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $select_input_hover_border_color = $color_grey_5;

/**
 * 选择器-input(single) hover状态下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $select_input_hover_color = $color_grey_9;

/**
 * 选择器-input(single)边框 active状态下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $select_input_active_border_color = $color_grey_9;

/**
 * 选择器-input(single)active状态下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $select_input_active_color = $color_grey_9;

/**
 * 选择器-错误状态下的hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-red-6
 */
var $select_color_error_hover = $color_red_6;

/**
 * 选择器-禁用状态下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-6
 */
var $select_input_disabled_color = $color_grey_6;

/**
 * 选择器-边框的禁用颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $select_input_disabled_border_color = $color_grey_4;

/**
 * 选择-颜色-边框-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-8
 */
var $select_hover_border_color = $color_grey_8;

export { $select_border_radius_xs, $select_color_border, $select_color_error_hover, $select_color_fill_secondary, $select_color_split, $select_color_text, $select_color_text_disabled, $select_control_item_bg_active, $select_control_item_bg_hover, $select_dropdown_active_color, $select_dropdown_hover_color, $select_dropdown_option_bg_color, $select_dropdown_option_color, $select_hover_border_color, $select_input_active_border_color, $select_input_active_color, $select_input_disabled_border_color, $select_input_disabled_color, $select_input_hover_border_color, $select_input_hover_color, $select_multiple_item_color_text, $select_multiple_item_disabled_color };
